<template>
  <router-view />
</template>

<script>

import moment from 'moment';

import store from '@/store';

export default {
  async created () {
    // Configure moment
    moment.locale('fr');

    // Wait for your initial data to load
    await store.dispatch('getAppLoad');
  }
};
</script>

<style>
.selectItem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: nowrap;
  text-wrap: nowrap;
  overflow: hidden;
  gap: 2px;
}

.selectLabel {
  overflow: hidden;
  text-overflow: ellipsis;
}

.selectCount {
  background-color: rgba(199, 27, 0, 0.9);
  border-radius: 4px;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  font-weight:500;
  min-width: 24px;
  height: 24px;
  padding: 0px 3px 0px 3px;
  color: white;
}
</style>
